import causeMedical from '../images/causes/1.png';
import causeEducation from '../images/causes/2.png';
import causeOrphanage from '../images/causes/3.png';
import causeSocial from '../images/causes/4.png';
import aboutImage from '../images/1.png';
import heroImage from '../images/home-bg.jpg';
import volunteerImage from '../images/vol-bg.png';

export const CONTACT = {
  phone: '+91-6364746723',
  phoneHref: 'tel:+91-6364746723',
  email: 'info@raisingsmiles.in',
  emailHref: 'mailto:info@raisingsmiles.in',
  location: 'Raising Smiles, Kemmannu, Udupi, Karnataka - 576105',
  shortLocation: 'Udupi, Karnataka',
  facebook: 'https://www.facebook.com/raisingsmiles',
  instagram: 'https://www.instagram.com/raisingsmiles2015/',
  donate: 'https://api.whatsapp.com/send?phone=916364746723&text=Hi Raising Smiles! I want to be a Donor.',
  whatsapp: 'https://api.whatsapp.com/send?phone=916364746723&text=Hi, Raising Smiles!',
  bloodDonation: 'https://chat.whatsapp.com/4sBhqdkCDHO0f3M9DRCSo8',
};

export const IMAGES = {
  about: aboutImage,
  hero: heroImage,
  volunteer: volunteerImage,
};

export const causes = [
  {
    title: 'Medical Aid',
    category: 'Healthcare',
    image: causeMedical,
    description: 'Critical support for families navigating medical emergencies and essential treatment needs.',
    impact: 'Emergency help when care cannot wait',
  },
  {
    title: 'Education Aid',
    category: 'Education',
    image: causeEducation,
    description: 'Helping students continue learning with fees, supplies, and support that opens brighter futures.',
    impact: 'Keeping opportunity within reach',
  },
  {
    title: 'Aid to Orphanages',
    category: 'Child welfare',
    image: causeOrphanage,
    description: 'Standing beside orphanages with food, essentials, and care for vulnerable children.',
    impact: 'Nurturing safer childhoods',
  },
  {
    title: 'Social Causes',
    category: 'Community',
    image: causeSocial,
    description: 'Responding to local needs with compassionate, practical help through community participation.',
    impact: 'Small acts, shared progress',
  },
];

export const impactStats = [
  { value: '2015', label: 'Founded with a mission to serve' },
  { value: '80+', label: 'Community support events' },
  { value: '4', label: 'Core causes supported' },
  { value: '15+', label: 'Active volunteers and supporters' },
];
